module.exports = __webpack_public_path__ + "images/category_lp/camera/man_50_de924ac9bc9734a6ed0d5839d72f2587.png";